import React, { useEffect, useRef, useState } from 'react';
import styles from './WorkFlow.module.scss';
import WorkflowHeader from './components/header/WorkFlowHeader';
import { useBrandingContext } from 'app-context/BrandingsContext';
import WorkFlowBar from './components/work-flow-bar/WorkFlowBar';
import FlowNavigator from './components/flow-navigator/FlowNavigator';
import ReactFlowChart from './components/chart/ReactFlowChart';
import {
  useWorkflowContext,
  WorkflowProvider,
} from 'app-context/worflow/WorkflowContext';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { workflow } from 'hooks/endpoints';
import { usePost } from 'hooks/usePost';
import { useFetch } from 'hooks/useFetch';
import { nodeType } from './components/functions/nodeType';
import Loader from 'component/atom/loader/Loader';
import toast from 'react-hot-toast';
import {
  getIncomers,
  MarkerType,
  ReactFlowProvider,
  useNodesInitialized,
  useReactFlow,
  useViewport,
} from '@xyflow/react';
import WorkFlowChat from './components/work-flow-chat/WorkFlowChat';
import ConfirmationModal from 'component/hoc/success-modal/ConfirmationModal';
import { compareWorkflows } from './components/functions/compareWorkflowData';
import TourModal from 'component/hoc/tour-modal/TourModal';
import { useTour } from 'app-context/tourContext/TourContext';
import { useUserContext } from 'app-context/user/UserContext';

const Workflow = ({ flag, setFlag }) => {
  const { id } = useParams();
  const location = useLocation();
  const flowParent = useRef();
  const navigate = useNavigate();
  const { brandingData } = useBrandingContext();
  const nodesInitialized = useNodesInitialized();
  const { zoom, x, y } = useViewport();
  const { screenToFlowPosition } = useReactFlow();
  const { selectedBot, setSelectedBot } = useUserContext();
  const { sideBar_BackgroundColor, page_TextColor } = brandingData || {};
  const {
    workflowData,
    setWorkflowData,
    resetWorkflowData,
    isChanged,
    setInitialWorkflowData,
  } = useWorkflowContext();
  const [isError, setIsError] = useState(false);
  const [isSystem, setIsSystem] = useState(false);
  const [isBack, setIsBack] = useState(false);

  const {
    data: dataById,
    isFetching,
    refetch,
  } = useFetch(['workflowByIdData', id], workflow.getWorkflowById(id), {
    enabled: true,
  });

  const { mutate: CreateWorkflow, isPending } = usePost({
    onSuccessToast: 'Saved Successfully',
    toastType: 'add',
  });

  useEffect(() => {
    const storedBot = localStorage.getItem('selectedBot');
    if (storedBot) {
      try {
        setSelectedBot(JSON.parse(storedBot));
      } catch {
        localStorage.removeItem('selectedBot');
      }
    }
  }, []);

  // const [popover, setPopover] = useState({
  //   visible: false,
  //   x: 0,
  //   y: 0,
  // });

  // const handleRightClick = (e) => {
  //   e.preventDefault();
  //   setPopover({
  //     visible: true,
  //     x: e.clientX,
  //     y: e.clientY,
  //   });
  // };

  //validate false if there is a target node not connected
  const validateWorkflow = () => {
    const { nodes, edges } = workflowData;
    const unconnectedNodes = nodes.filter((node) => {
      if (node.type === 'initialNode' || node.type === 'endNode') return false;
      const hasIncoming = getIncomers(node, nodes, edges).length > 0;
      return !hasIncoming;
    });
    if (unconnectedNodes.length > 0) {
      toast.error('All nodes must be connected to both a source and a target.');

      return false;
    }
    return true;
  };

  const navigateBack = () => {
    setFlag(false);
    if (!dataById?.data?.botName) {
      navigate(`/console/workflow`);
    } else {
      navigate(`/bot/workflow/${workflowData?.botId}`);
    }
    setTimeout(() => {
      resetWorkflowData();
    }, [500]);
  };

  //post api
  const postWorkflow = () => {
    if (validateWorkflow()) {
      const isErrorFound = workflowData?.nodes?.some((node) => node.is_Error);
      const valuesToSend = {
        ...workflowData,
        id: dataById?.data?.id,
        name: dataById?.data?.name,
        botId: dataById?.data?.botId,
        // idleTime: dataById?.data?.idleTime,
        description: dataById?.data?.description,
        zoom: zoom,
        viewPortX: x,
        viewPortY: y,
        is_Error: isErrorFound || false,
      };

      CreateWorkflow(
        {
          url: workflow.createWorkflow,
          data: valuesToSend,
        },
        {
          onSuccess: () => {
            if (isBack) {
              navigateBack();
            } else {
              window.location.reload();
              refetch();
              setFlag(false);
            }
          },
        }
      );
    }
  };

  //handle if there is error or no
  const handleCreateWorkflow = () => {
    if (
      workflowData?.isSystem == true &&
      workflowData?.nodes?.some((node) => node.is_Error)
    ) {
      setIsSystem(true);
    } else {
      if (workflowData?.nodes?.some((node) => node.is_Error)) {
        if (validateWorkflow()) {
          setIsError(true);
        }
      } else {
        postWorkflow();
      }
    }
  };

  const handleBack = () => {
    setIsBack(true);
    if (
      compareWorkflows(dataById?.data, workflowData) &&
      isChanged?.length == 0
    ) {
      navigateBack();
    } else {
      setIsError(true);
    }
  };
  const handleNavigateBackIfIsSystem = () => {
    if (
      isBack &&
      workflowData?.isSystem == true &&
      workflowData?.nodes?.some((node) => node.is_Error)
    ) {
      setIsSystem(true);
    } else {
      postWorkflow();
    }
  };
  const handleAddNode = (child) => {
    const newNodeId = (
      Math.max(
        0,
        ...(workflowData?.nodes?.map((node) => Number(node.id)) || [])
      ) + 1
    ).toString();
    const bounds = flowParent.current?.getBoundingClientRect();

    const center = {
      x: bounds.left + (bounds.right - bounds.left) / 2,
      y: bounds.top + (bounds.bottom - bounds.top) / 2,
    };
    const randInt = (max) => Math.floor(Math.random() * Math.floor(max));
    const position = screenToFlowPosition({
      x: center.x + randInt(100),
      y: center.y + randInt(100),
    });

    const newNode = {
      id: newNodeId,
      type: child.type,
      nodeType: child.nodeType,
      position,
      is_Error: true,
      data: { isNew: true },
    };
    setWorkflowData((prevParams) => ({
      ...prevParams,
      nodes: [...prevParams.nodes, newNode],
    }));
    setTimeout(() => {
      setWorkflowData((prevParams) => ({
        ...prevParams,
        nodes: prevParams.nodes?.map((node) =>
          node.id === newNodeId
            ? { ...node, data: { ...node.data, isNew: false } }
            : node
        ),
      }));
    }, 1000);
  };

  const handleCloseModal = () => {
    setIsError(false);
    setIsSystem(false);
    setIsBack(false);
  };

  useEffect(() => {
    const isErrorFound = workflowData?.nodes?.some((node) => node.is_Error);
    setWorkflowData((prevParams) => ({
      ...prevParams,
      isError: isErrorFound,
    }));
  }, [workflowData?.nodes?.some((node) => node.is_Error)]);

  useEffect(() => {
    if (!dataById?.data) return;
    setWorkflowData({
      ...dataById.data,
      nodes: dataById.data.nodes?.length
        ? dataById.data.nodes.map((node) => ({
            ...node,
            position: { x: node.positionX, y: node.positionY },
            type: nodeType(node.nodeType),
            id: node.nId?.toString(),
          }))
        : [
            {
              id: '1',
              type: 'initialNode',
              nodeType: 12,
              position: { x: 200, y: 300 },
              is_Error: true,
            },
          ],
      edges:
        dataById?.data?.edges?.length > 0
          ? dataById?.data?.edges?.map((edge) => ({
              ...edge,
              source: edge.source.toString(),
              target: edge.target.toString(),
              type: 'smoothstep',
              style: { strokeWidth: 1 },
              markerEnd: { type: MarkerType.ArrowClosed, color: '#7D7D7D' },
            }))
          : [],
    });
    setInitialWorkflowData(
      dataById.data.nodes?.length
        ? dataById.data.nodes.map((node) => ({
            ...node,
            position: { x: node.positionX, y: node.positionY },
            type: nodeType(node.nodeType),
            id: node.nId?.toString(),
          }))
        : [
            {
              id: '1',
              type: 'initialNode',
              nodeType: 12,
              position: { x: 200, y: 300 },
              is_Error: true,
            },
          ]
    );
  }, [dataById, id]);

  useEffect(() => {
    if (nodesInitialized && flag == false) {
      setWorkflowData((prev) => ({
        ...prev,
        edges:
          dataById?.data?.edges?.length > 0
            ? dataById?.data?.edges?.map((edge) => ({
                ...edge,
                source: edge.source.toString(),
                target: edge.target.toString(),
                type: 'smoothstep',
                style: { strokeWidth: 1 },
                markerEnd: { type: MarkerType.ArrowClosed, color: '#7D7D7D' },
              }))
            : [],
      }));
      setFlag(true);
    }
  }, [nodesInitialized, id, dataById]);

  useEffect(() => {
    if (id) {
      refetch();
    }
  }, [id]);

  return (
    <div
      key={id}
      className={styles['work-flow']}
      style={{ color: page_TextColor }}
    >
      <WorkflowHeader
        backgroundColor={sideBar_BackgroundColor}
        brandingData={brandingData}
        onSave={handleCreateWorkflow}
        data={dataById}
        isPending={isPending}
        id={id}
        resetWorkflowData={resetWorkflowData}
        refetch={refetch}
        setFlag={setFlag}
        handleBack={handleBack}
      />

      <div className={styles['play-ground']}>
        <WorkFlowBar
          botId={dataById?.data?.botId}
          setFlag={setFlag}
          refetch={refetch}
        />
        <FlowNavigator
          workflowData={workflowData}
          setWorkflowData={setWorkflowData}
          handleAddNode={handleAddNode}
        />
        {dataById?.data?.botId ? (
          <WorkFlowChat botId={dataById?.data?.botId} />
        ) : null}
      </div>

      <div
        style={{ height: '93%' }}
        ref={flowParent}
        // onContextMenu={handleRightClick}
        // onClick={() => setPopover({ ...popover, visible: false })}
      >
        {isFetching ? (
          <div className={styles['loader-container']}>
            <Loader isComponent />
          </div>
        ) : (
          <ReactFlowChart
            key={
              flag === false
                ? workflowData?.edges?.map((edge) => edge.id).join(',')
                : 'default'
            }
            isFetching={isFetching}
            fetchedData={dataById?.data}
            flag={flag}
            nodesInitialized={nodesInitialized}
          />
        )}
      </div>

      {/* {popover.visible && (
        <div
          className={styles['dropdown']}
          style={{
            top: popover.y,
            left: popover.x,
          }}
          onClick={() => handleAddNode('initialNode')}
        >
          <p>Add Trigger</p>
        </div>
      )} */}
      <ConfirmationModal
        isOpen={isError && !isBack}
        onClose={handleCloseModal}
        onSubmit={postWorkflow}
        closeOnSubmit={true}
        onApproveButton={{ text: 'Save' }}
        text='This workflow is incomplete.'
        subText={'Do you wish to save anyway or to add required values.'}
        type='save'
        isLoading={isPending}
      />
      <ConfirmationModal
        isOpen={isError == true && isBack == true}
        onClose={() => (setIsError(false), setIsBack(false))}
        onSubmit={handleNavigateBackIfIsSystem}
        closeOnSubmit={true}
        onApproveButton={{ text: 'Save' }}
        text='Do you want to save?'
        type='save'
        isLoading={isPending}
        handleCancel={isBack ? navigateBack : null}
      />
      <ConfirmationModal
        isOpen={isSystem}
        onClose={handleCloseModal}
        text='This workflow is incomplete.'
        subText='This is a system workflow, fill all required fields.'
      />
    </div>
  );
};
const WorkflowProviderView = () => {
  const [flag, setFlag] = useState(false);
  const { showModal } = useTour();

  return (
    <WorkflowProvider>
      <ReactFlowProvider>
        <Workflow flag={flag} setFlag={setFlag} />
      </ReactFlowProvider>
      {showModal && <TourModal />}
    </WorkflowProvider>
  );
};
export default WorkflowProviderView;
